import { Store } from '@ngxs/store';
import { UPDATE_COVERAGE_ALERT, STORE_SHOWED_ONE_ALLIANZ_POP_UP } from '@store/sat-motor/sat-motor.action';
import { Component, Inject } from '@angular/core';
import { NX_MODAL_DATA, NxModalRef } from '@aposin/ng-aquila/modal';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-one-allianz-message',
  standalone: true,
  imports: [
    SharedModule,
  ],
  templateUrl: './one-allianz-message.component.html',
  styleUrl: './one-allianz-message.component.scss'
})
export class OneAllianzMessageComponent {

  message: any;

  constructor(
    private store: Store,
    @Inject(NX_MODAL_DATA) readonly parentData: any,
    private dialogRef: NxModalRef<any>,
  ) {
    if (parentData && parentData.showNonEligible) {
      this.message = 'The customer is ineligible for the complimentary 1 unit of Road Warrior as the customer is no longer a One Allianz customer.';
    } else {
      this.message = 'The customer is a One Allianz customer and is eligible for complimentary 1 unit of Road Warrior.';
    }
  }

  onClickOK() {
    // this.store.dispatch(new STORE_SHOWED_ONE_ALLIANZ_POP_UP(true)).subscribe(() => {
    //   this.store.dispatch(new UPDATE_COVERAGE_ALERT({ alimCustomerEligible: false, alimCustomerEligibleShowed: true }));
    // });
  }

}
